import React, { Component } from 'react';
import {connect} from 'react-redux';
import compose from 'recompose/compose';
import { reduxForm, formValueSelector } from 'redux-form';
import PropTypes from 'prop-types';

import { EDIT_COPPER_FORM, PREPREG } from '../../../constants/globals';

import EditCopperFields from './EditCopperFields';
import CopperSummary from './CopperSummary';
import EditFormActions from './EditFormActions';
import Warnings from './LayerWarnings';
import { getNeighborPrepreg, validate, isOuterCopper } from '../../../lib/copper';
import { Copper } from '../../../models';
import Material from '../../../models/Material';

const formName = EDIT_COPPER_FORM; 

export class EditCopperForm extends Component {
  constructor(props) {
    super(props);
    this.initializeForm();
  }

  onSubmit(value) {
    const { onSubmit, handleSubmit } = this.props;

    handleSubmit(onSubmit)(value);
  }

  initializeForm() {
    const { initialize, layer } = this.props;
    const {
      copperFill,
      name,
      weight,
      signal,
      transmissionWidth,
      transmissionSpacing,
      plating
    } = layer;
    initialize({
      copperFill,
      name,
      weight,
      signal,
      transmissionWidth,
      transmissionSpacing,
      plating
    });
  }

  render() {
    const {
      invalid,
      layer,
      layers,
      lengthUnit,
      mirror,
      onCancel,
      pristine,
      signal,
      copperFill = 0,
      plating = 0,
      weight = 0,
    } = this.props;
    const canSubmit = !(pristine || invalid);
    const onSubmit = this.onSubmit.bind(this);
    const { index } = layer;

    const prepreg  = getNeighborPrepreg(layers, index, PREPREG);
    const isOuter = isOuterCopper(layer, layers);
    const newCopper = new Copper({
      weight,
      signal,
      copperFill,
      plating,
    });

    // typeIndex is supposed to be assigned after initialization
    newCopper.typeIndex = layer.typeIndex;
    newCopper.getLayers = () => layers;

    const { warnings } = validate(newCopper, index, layers);

    return (
      <form onSubmit={onSubmit}>
        <EditCopperFields
          layer={layer}
          signal={signal}
          isOuter={isOuter}
          lengthUnit={lengthUnit}
        />
        <CopperSummary
          layer={newCopper}
          layers={layers}
          prepreg={prepreg}
          lengthUnit={lengthUnit}
        />
        <Warnings texts={warnings} />
        <EditFormActions
          layer={layer}
          mirror={mirror}
          onCancel={onCancel}
          canSubmit={canSubmit}
        />
      </form>
    );
  }
}

const selector = formValueSelector(formName);
function mapStateToProps(state){
  return {
    copperFill: selector(state, 'copperFill'), 
    signal: selector(state, 'signal'), 
    weight: selector(state, 'weight'),
    plating: selector(state, 'plating'),
  };
}

const formConfig = {
  form: formName,
};

EditCopperForm.propTypes = {
  // props from the parent component
  layer:      PropTypes.instanceOf(Copper).isRequired,
  layers:     PropTypes.arrayOf(PropTypes.instanceOf(Material)).isRequired,
  mirror:     PropTypes.instanceOf(Copper).isRequired,
  onCancel:   PropTypes.func.isRequired,
  onSubmit:   PropTypes.func.isRequired,
  lengthUnit: PropTypes.string.isRequired,

  // redux-form props
  initialize:   PropTypes.func.isRequired,
  invalid:      PropTypes.bool.isRequired,
  pristine:     PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  
  // mapStateToProps
  copperFill: PropTypes.number,
  plating:    PropTypes.number,
  signal:     PropTypes.bool,
  weight:     PropTypes.number,
};

EditCopperForm.defaultProps = {
  signal: false,
  copperFill: undefined,
  plating: undefined,
  weight: undefined,
}

export default compose(
  reduxForm(formConfig),
  connect(mapStateToProps)
) (EditCopperForm);


// WEBPACK FOOTER //
// ./src/components/StackupDesign/EditLayer/EditCopperForm.js